/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  BranchDto,
  GetAllBranchesParams,
  IReadOnlyListOfBranchDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all branch enumeration values, with an optional filter.
 */
export const getAllBranches = (
    params?: GetAllBranchesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfBranchDto>>,) => {
      return customInstance<IReadOnlyListOfBranchDto>(
      {url: `/deployment/branches`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the Branch identified by the route id.
 */
export const getBranchById = (
    id: number,
 options?: SecondParameter<typeof customInstance<BranchDto>>,) => {
      return customInstance<BranchDto>(
      {url: `/deployment/branches/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllBranchesResult = NonNullable<Awaited<ReturnType<typeof getAllBranches>>>
export type GetBranchByIdResult = NonNullable<Awaited<ReturnType<typeof getBranchById>>>
